var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRigthChevronBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.307,
    height: 23.744,
    viewBox: "0 0 14.307 23.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6793",
    "data-name": "Group 6793",
    transform: "translate(0 23.744) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5312",
    "data-name": "Path 5312",
    d: "M11.872,14.307a2.428,2.428,0,0,1-1.722-.713L.713,4.157A2.435,2.435,0,1,1,4.157.713l7.715,7.715L19.587.713a2.435,2.435,0,0,1,3.444,3.444l-9.437,9.437A2.428,2.428,0,0,1,11.872,14.307Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRigthChevronBlack);
export default __webpack_public_path__ + "static/media/rigth-chevron-black.b3fa1239a1ffc8910d6441451a5cc0e4.svg";
export { ForwardRef as ReactComponent };